import { z } from "zod";

export const manualQuoteItemSchema = z.object({
  id: z.string(),
  isManual: z.boolean().default(true),
  label: z.string().optional(),
  partNo: z.string().optional(),
  description: z.string().min(1, "Description is required"),
  category: z.string().optional(),
  toolingType: z.string().optional(),
  machineType: z.string().optional(),
  itemName: z.string().optional(),
  partName: z.string().optional(),
  currency: z.enum(["EUR", "USD"]),
  price: z.coerce.number().nonnegative("Price must be positive"),
  qty: z.coerce.number().int().nonnegative().default(1),
});

export type ManualQuoteItemFormData = z.infer<typeof manualQuoteItemSchema>;
